module.exports = __webpack_public_path__ + "assets/eccb1814f137b6f2fac5b36c564cf354.ttf";